import packageInfo from '../../package.json';

export const environment = {
    production: true,
    serverUrl: '',
    version: packageInfo.version,
};
